import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AppInsightsProvider } from 'Features/Error/AppInsightsProvider'
import { AppThemeProvider } from 'Features/App/AppThemeProvider'
import { Toaster } from 'Common/Supplyvue-ui'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '../../'

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  })

  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
          <Toaster />
          <AppInsightsProvider>{children}</AppInsightsProvider>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </AppThemeProvider>
      </QueryClientProvider>
    </MsalProvider>
  )
}
